import axios from "axios";

import ApiException from "./ApiException";
import config from "@/app.config.json";
import { ValidacaoResult } from "@/services/Interfaces/IValidacaoResult";

const urlBase = `${config.urlApi}/Clientes`;  //import.meta.env.VITE_URL_API;

const urls = {
  obter: `${urlBase}`,
  obterResumido: `${urlBase}/ObterResumido`,
  obterPorId: `${urlBase}`,
  validarCartao: `${urlBase}/ValidarCartao`,
  adicionar: `${urlBase}`,
  alterar: `${urlBase}`,
  excluir: `${urlBase}`,
  gerarSenhaTemp: `${urlBase}/GerarSenhaTemporaria`,
  alterarSenha: `${urlBase}/AlterarSenha`,
}


function getToken(): string {

  const x = localStorage.getItem('user');

  if (x != null) {
    const user = JSON.parse(x);

    if (user && user.accessToken) {
      return `Bearer ${user.accessToken}`;
    } else {
      return "";
    }
  }
  else
    return "";
}

export const obterPorId = (id: number): Promise<Cliente> => {
  return new Promise((resolve, reject) => {

    const params = {
      id: id
    }

    console.log("obterPorId", id);
    axios.defaults.headers.common.Authorization = getToken();

    axios
      .get(`${urls.obterPorId}/${id}`, { params })
      .then((response) => {
        return resolve(response.data);
      })
      .catch(error => reject(new ApiException(error || "Falha ao obter por id")));
  });
};

export interface ValidacaoCartao {
  nome: string;
  ativo: boolean;
}

export const validarCartao = (id: number): Promise<ValidacaoCartao> => {
  return new Promise((resolve, reject) => {

    axios
      .get(`${urls.validarCartao}/${id}`)
      .then((response) => {
        return resolve(response.data);
      })
      .catch(error => reject(new ApiException(error || "Falha ao validar cartão")));
  });
};

export const obter = (params?: Filtros | null | any): Promise<ResultClientes> => {
  return new Promise((resolve, reject) => {

    axios.defaults.headers.common.Authorization = getToken();

    axios
      .get(urls.obter, { params })
      .then((r) => {
        return resolve(r.data);
      })
      .catch(error => reject(new ApiException(error || "Falha ao obter ")));
  });
};

export const obterResumido = (params?: Filtros | null | any): Promise<ResultClientes> => {
  return new Promise((resolve, reject) => {

    axios.defaults.headers.common.Authorization = getToken();

    axios
      .get(urls.obterResumido, { params })
      .then((r) => {
        return resolve(r.data);
      })
      .catch(error => reject(new ApiException(error || "Falha ao obter ")));
  });
};

export async function salvar(model: Cliente): Promise<Cliente> {
  try {
    // Configurar token de autorização
    axios.defaults.headers.common.Authorization = getToken();

    if (model.clienteId && model.clienteId > 0) {
      return (await axios.put(`${urls.alterar}/${model.clienteId}`, model)).data
    } else {
      return (await axios.post(urls.adicionar, model)).data
    }
  } catch (error: any) {
    throw new ApiException(error || "Falha ao salvar ");
  }
}

export async function excluir(id: number): Promise<void> {
  await axios.delete(`${urls.excluir}/${id}`)
}

export async function gerarSenhaTemporaria(model: GerarSenhaTempDto): Promise<string> {
  try {
    // Configurar token de autorização
    axios.defaults.headers.common.Authorization = getToken();
    return (await axios.post(urls.gerarSenhaTemp, model)).data
  } catch (error: any) {
    throw new ApiException(error || "Falha ao salvar ");
  }
}

export const alterarSenha = (clienteId: number, senhaNova: string, confirmaNovaSenha: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common.Authorization = getToken();

    const params = { clienteId, senhaNova, confirmaNovaSenha }

    axios
      .post(urls.alterarSenha, params)
      .then(() => resolve())
      .catch(error => reject(new ApiException(error || "Falha ao alterar senha")));
  });
};

export interface Filtros {
  clienteId: number | null;
  nome: string | null;
  cpf: string | null;
  ativo: boolean | null;
  telefone: string | null;
  cidadeId: number | null;
  usuarioId: number | null;
  cortesia: boolean | null;
  comCidades?: boolean | null;
  comVendedor?: boolean | null;
  comDependentes?: boolean | null;
  paginaAtual: number | undefined;
  tamanhoPagina: number | undefined;
  ordenarPor: string | undefined;
}

export interface ResultClientes {
  dados: Cliente[];
  totalRegistros: number;
}

export interface Cidade {
  cidadeId: number;
  nome: string;
  uf?: string | null;
}

export interface Cliente {
  clienteId: number;
  usuarioId: number;
  nome: string;
  cpf: string | null;
  rg: string | null;
  rgExpedidor: string | null;
  telefone: string | null;
  celular: string | null;
  logradouro: string | null;
  numero: string;
  bairro: string | null;
  cidadeId: number | null;
  cep: string | null;
  complemento: string | null;
  nomeConjuge: string | null;
  cpfConjuge: string | null;
  cortesia: boolean;
  dataEntregaCartao: Date | null;
  dataNascimento: Date | null;
  email: string | null;
  observacoes: string | null;
  senha: string | null;
  clienteIndicouId?: number;
  ativo: boolean;
  permCartao: boolean;
  cidade?: Cidade | null;
  usuario: Usuario;
  dataCadastro?: Date ;
  usuCadastroId: number | null;
  dataAlteracao?: Date | null;
  usuAlteracaoId: number | null;
  dataExclusao: Date | null;
  usuExclusaoId: number | null;
  modelState: ValidacaoResult;
}

export interface Usuario {
  usuarioId: number;
  nomeCompleto?: string | null;
}


export interface GerarSenhaTempDto {
    clienteId: number;
    minutos: number;
}